/**
 * MenuListPresenter
 * --
 */
import React, { useRef, useState, useEffect } from 'react';
import {
  Content,
  Row,
  Col,
  Title,
  // Collapse,
  MenuList,
  Descriptions,
  ModalLayout,
  Text,
  // DragAndDrop,
  UploadFile,
  OptionForm,
} from 'components';
import { Button, Avatar, Input, Radio, Select, Flex } from 'antd';
import { stringToMoneyFormat, STORE_URL } from 'utils';
import CONSTANTS from 'constants';
// import { XAxis, YAxis, BarChart, Bar, Tooltip } from 'recharts';

const GRADE_BENEFIT = {
  discount_rate: 0,
  discount_type: 'R',
  reserve_rate: 0,
  reserve_type: 'R',
};

const MenuListPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const {
    menuData,
    isOpened,
    modalData,
    modalType,
    options,
    nutritionalInfo,
    files,
    thumbnailFiles,
    onOpen,
    onChange,
    onSubmit,
    onOptionChange,
    onOptionList,
    onNuritionalChange,
    onFileChange,
    onThumbnailFileChange,
    onDelete,
    selectedItem,
    onSelectedItem,
    //!SECTION
    grades = [],
  } = props;
  /* ===== STATE ===== */
  // 선택한 아이템

  const chartRef = useRef(null);
  const [chartWidth, setChartWidth] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  // console.log('selectedItem', selectedItem);
  // console.log('files', files);
  /* ===== VARIABLE ===== */
  const optionTemp = {
    option_id: 1,
    option_title: '',
    option_type: 'CHOICE',
    type: 'DEFAULT',
    option: [
      {
        option_key: 1,
        option_name: '',
        option_type: '',
        option_price: 0,
        count: 0,
        default: false,
      },
    ],
  };

  const data = React.useMemo(() => {
    let value = menuData;
    if (searchValue) {
      value = value
        ?.map((item) => ({
          ...item,
          menus: item.menus.filter((menu) =>
            menu.menu_name.includes(searchValue),
          ),
        }))
        ?.filter((item) => item.menus.length > 0);
    }

    return value;
  }, [searchValue, menuData]);
  // console.log(modalData);
  /* ===== FUNCTION ===== */
  /**
   * 한달치 판매량 데이터 정제
   * --
   */
  const generateSalesData = () => {
    const salesData = [];
    const today = new Date();

    for (let i = 0; i < 30; i++) {
      const date = new Date();
      date.setDate(today.getDate() - i);
      const day = `${String(date.getMonth() + 1).padStart(2, '0')}-${String(
        date.getDate(),
      ).padStart(2, '0')}`;
      const sales = Math.floor(Math.random() * 5000); // 0에서 4999까지의 랜덤 판매량
      salesData.push({ day, sales });
    }

    return salesData.reverse(); // 최근 날짜가 마지막에 오도록 배열을 뒤집기
  };
  /* ===== HOOKS ===== */

  useEffect(() => {
    const call = (e) => {
      setChartWidth(chartRef.current.clientWidth);
    };

    if (chartRef.current) call();

    window.addEventListener('resize', call);

    return () => {
      window.removeEventListener('resize', call);
    };
  }, [chartRef]);

  /* ===== RENDER ===== */

  // console.log('data: ', data);
  return (
    <>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        {/* === 컨테이너: start === */}
        <Title size={3} style={{ marginBottom: 13 }}>
          메뉴 관리
        </Title>
        <Content maxWidth={'100%'} padding={0} backgroundColor={'#fff'}>
          <Row>
            <Col x={24}>
              <Content
                maxWidth={'100%'}
                borderRadius={4}
                padding={20}
                backgroundColor="none"
              >
                <Row gutter={[1, 1]}>
                  {/* ===== 메뉴목록 ===== */}
                  <Col x={6}>
                    <Content maxWidth={'100%'} padding={0}>
                      <Input
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        placeholder="메뉴 검색"
                        style={{ marginBottom: 10 }}
                      />
                      <Content
                        maxWidth={'100%'}
                        padding={0}
                        backgroundColor="#FAFAFA"
                        className="custom-scroll"
                        style={{
                          height: '100%',
                          maxHeight: 990,
                          overflow: 'scroll',
                        }}
                      >
                        {data?.map((category) => (
                          <MenuList
                            key={`category_${category?.product_category_id}`}
                            title={category?.product_category_name}
                            data={category}
                            onMenuSelect={onSelectedItem}
                            selectedItem={selectedItem}
                          />
                        ))}
                        {/* {data?.map((category) => (
                        <Collapse
                          key={`category_${category?.product_category_id}`}
                          title={category?.product_category_name}
                          defaultOpened
                        >
                          {category.subCategories?.length > 0
                            ? category.subCategories.map((subCategory) => (
                                <div
                                  key={`subcategory_wrapper_${subCategory?.product_category_id}`}
                                  style={{
                                    marginLeft: '5%', // 하위 카테고리 들여쓰기
                                    backgroundColor: '#f7f7f7', // 하위 카테고리 배경색 설정
                                  }}
                                >
                                  <Collapse
                                    key={`subcategory_${subCategory?.product_category_id}`}
                                    title={
                                      <span style={{ paddingLeft: '20px' }}>
                                        {subCategory?.product_category_name}
                                      </span>
                                    }
                                    defaultOpened
                                  >
                                    {subCategory?.menus?.map((menu) => (
                                      <div
                                        key={`menu_${menu?.menu_id}`}
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          padding: 8,
                                          cursor: 'pointer',
                                          border:
                                            selectedItem?.menu_id ===
                                            menu?.menu_id
                                              ? '1px solid #2394E4'
                                              : '1px solid #EFEFEF',
                                          borderBottom:
                                            selectedItem?.menu_id ===
                                            menu?.menu_id
                                              ? '1px solid #2394E4'
                                              : '1px solid #DFDFDF',
                                          background:
                                            selectedItem?.menu_id ===
                                            menu?.menu_id
                                              ? 'rgba(28, 107, 244, 0.3)'
                                              : '#EFEFEF',
                                        }}
                                        onClick={() => setSelectedItem(menu)}
                                      >
                                        <div>
                                          <Avatar shape="square" size={30} />
                                        </div>
                                        <div style={{ paddingLeft: 7 }}>
                                          <h4>{menu?.menu_name}</h4>
                                          <p>
                                            {stringToMoneyFormat(
                                              menu?.price,
                                              '원'
                                            )}
                                          </p>
                                        </div>
                                      </div>
                                    ))}
                                  </Collapse>
                                </div>
                              ))
                            : // 상위 카테고리 메뉴
                              category?.menus?.map((menu) => (
                                <div
                                  key={`menu_${menu?.menu_id}`}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: 8,
                                    cursor: 'pointer',
                                    border:
                                      selectedItem?.menu_id === menu?.menu_id
                                        ? '1px solid #2394E4'
                                        : '1px solid #EFEFEF',
                                    borderBottom:
                                      selectedItem?.menu_id === menu?.menu_id
                                        ? '1px solid #2394E4'
                                        : '1px solid #DFDFDF',
                                    background:
                                      selectedItem?.menu_id === menu?.menu_id
                                        ? 'rgba(28, 107, 244, 0.3)'
                                        : '#EFEFEF',
                                  }}
                                  onClick={() => setSelectedItem(menu)}
                                >
                                  <div>
                                    <Avatar shape="square" size={30} />
                                  </div>
                                  <div style={{ paddingLeft: 7 }}>
                                    <h4>{menu?.menu_name}</h4>
                                    <p>
                                      {stringToMoneyFormat(menu?.price, '원')}
                                    </p>
                                  </div>
                                </div>
                              ))}
                        </Collapse>
                      ))} */}
                      </Content>
                      <div>
                        <Button
                          style={{
                            width: '50%',
                            borderRadius: 0,
                          }}
                          onClick={() => onOpen(isOpened, 'category')}
                        >
                          카테고리 추가
                        </Button>
                        <Button
                          type="primary"
                          style={{
                            width: '50%',
                            background: 'var(--primary-color)',
                            borderRadius: 0,
                          }}
                          onClick={() => onOpen(isOpened, 'menu')}
                          disabled={!data?.length}
                        >
                          메뉴 추가
                        </Button>
                      </div>
                    </Content>
                  </Col>

                  {/* ===== 상품 상세보기 ===== */}
                  <Col x={18}>
                    <Content maxWidth={'100%'} padding={20}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginBottom: 10,
                        }}
                      >
                        <Text size={14} weight={600} color={'#404040'}>
                          메뉴정보
                        </Text>
                        <div>
                          {selectedItem?.menu_id && (
                            <>
                              <Button
                                type="primary"
                                style={{
                                  background: 'var(--primary-color)',
                                  width: 73,
                                }}
                                onClick={() =>
                                  onOpen(isOpened, 'menu', { ...selectedItem })
                                }
                              >
                                편집
                              </Button>
                              <Button
                                type="default"
                                style={{
                                  width: 73,
                                }}
                                onClick={() =>
                                  window.confirm(
                                    `정말 ${selectedItem?.menu_name} 을(를) 삭제하시겠습니까?`,
                                  ) && onDelete(selectedItem?.menu_id || null)
                                }
                              >
                                삭제
                              </Button>
                            </>
                          )}
                        </div>
                      </div>
                      <Descriptions
                        align="left"
                        column={4}
                        ratio={[20, 30]}
                        items={[
                          {
                            key: 'menu_name',
                            label: '메뉴명',
                            children: selectedItem?.menu_name || '-',
                            span: 2,
                          },
                          {
                            key: 'sub_menu_name',
                            label: '서브메뉴명',
                            children: selectedItem?.sub_menu_name || '-',
                            span: 2,
                          },
                          {
                            key: 'menu_code',
                            label: '메뉴번호',
                            children: selectedItem?.menu_id || '-',
                            span: 2,
                          },
                          {
                            key: 'price',
                            label: '단가',
                            children: selectedItem?.price
                              ? stringToMoneyFormat(selectedItem.price, '원')
                              : '-',
                            span: 2,
                          },
                          {
                            key: 'menu_content',
                            label: '메뉴 설명',
                            children: selectedItem?.menu_content || '-',
                            span: 4,
                          },
                          {
                            key: 'temperature_option',
                            label: '온도 옵션',
                            children:
                              selectedItem?.temperature_option === 'ALL'
                                ? 'HOT / ICE'
                                : selectedItem?.temperature_option === 'HOT'
                                  ? 'HOT ONLY'
                                  : selectedItem?.temperature_option === 'ICE'
                                    ? 'ICE ONLY'
                                    : selectedItem?.temperature_option || '-',
                            span: 2,
                          },
                          {
                            key: 'type',
                            label: '메뉴 타입',
                            children:
                              selectedItem?.type === 'MD'
                                ? 'MD상품'
                                : selectedItem?.type === 'DESSERT'
                                  ? '디저트'
                                  : selectedItem?.type === 'ALC'
                                    ? '주류'
                                    : selectedItem?.type === 'ETC'
                                      ? '기타'
                                      : '일반',
                          },
                          {
                            key: 'is_show',
                            label: '노출 여부',
                            children: selectedItem?.is_show || '-',
                          },
                          {
                            key: 'menu_option',
                            label: '기타 옵션',
                            children:
                              selectedItem?.menu_option?.map(
                                (option, index) => (
                                  <div
                                    key={`option_${index}`}
                                    style={{
                                      padding: '10px 20px',
                                      borderBottom:
                                        index ===
                                        selectedItem.menu_option.length - 1
                                          ? 'none'
                                          : '1px solid rgba(112, 115, 124, 0.2)',
                                    }}
                                  >
                                    <Text
                                      size={13}
                                      weight={600}
                                      color={'#454545'}
                                    >
                                      {option.option_title || 'Option'}
                                    </Text>
                                    <Radio.Group
                                      style={{ marginTop: 8 }}
                                      value=""
                                    >
                                      {option.option.map((optItem) => (
                                        <Radio
                                          key={`item_${optItem.option_key}`}
                                          value={optItem}
                                        >
                                          {optItem.option_name || 'Option Name'}
                                        </Radio>
                                      ))}
                                    </Radio.Group>
                                  </div>
                                ),
                              ) || '-',
                            span: 4,
                            style: { padding: 0 },
                          },
                          {
                            key: 'nutritional_information',
                            label: '영양 정보',
                            children:
                              selectedItem?.nutritional_information?.map(
                                (info, index) => (
                                  <div
                                    key={`nutritional_info_${index}`}
                                    style={{ marginBottom: 10 }}
                                  >
                                    <Text
                                      size={13}
                                      weight={600}
                                      color={'#454545'}
                                    >
                                      {info.nutritional_title}:{' '}
                                      {info.nutritional_amount}
                                      {info.nutritional_type}
                                    </Text>
                                  </div>
                                ),
                              ) || '-',
                            span: 4,
                          },
                          {
                            key: 'allergen_ingredient',
                            label: '알레르기 유발 성분',
                            children: selectedItem?.allergen_ingredient || '-',
                            span: 4,
                          },
                          {
                            key: 'exchange_return_policy',
                            label: '교환/반품 안내',
                            children:
                              selectedItem?.exchange_return_policy || '-',
                            span: 4,
                          },
                          {
                            key: 'is_present',
                            label: '선물 가능 여부',
                            children:
                              selectedItem?.is_present === 'Y'
                                ? '선물 가능'
                                : '선물 불가',
                            span: 4,
                          },
                          {
                            key: 'present_information',
                            label: '선물 관련 정보',
                            children: selectedItem?.present_information ? (
                              <div>
                                <div>
                                  <strong>유효기간:</strong>{' '}
                                  {
                                    selectedItem.present_information
                                      .present_expired_date
                                  }
                                  일
                                </div>
                                <div>
                                  <strong>최대 연장 횟수:</strong>{' '}
                                  {
                                    selectedItem.present_information
                                      .present_postponed_deadline
                                  }
                                  회
                                </div>
                              </div>
                            ) : (
                              '-'
                            ),
                            span: 4,
                          },
                          {
                            key: 'menu_file',
                            label: '이미지',
                            children: (
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  flexWrap: 'wrap',
                                  padding: '20px 0px',
                                }}
                              >
                                {selectedItem?.menu_file
                                  ?.filter((file) => file.type === 'THUMBNAIL')
                                  ?.map((file, index) => (
                                    <Avatar
                                      key={`img_${index}`}
                                      size={100}
                                      shape="square"
                                      style={{ marginRight: 10 }}
                                      src={`${STORE_URL}/${file.file_url}`}
                                    />
                                  )) || '-'}
                                {selectedItem?.menu_file
                                  ?.filter((file) => file.type !== 'THUMBNAIL')
                                  ?.map((file, index) => (
                                    <Avatar
                                      key={`img_${index}`}
                                      size={100}
                                      shape="square"
                                      style={{ marginRight: 10 }}
                                      src={`${STORE_URL}/${file.file_url}`}
                                    />
                                  )) || '-'}
                              </div>
                            ),
                            span: 4,
                          },
                          // {
                          //   key: `7`,
                          //   label: '매출',
                          //   children: (
                          //     <div style={{ padding: '20px 0px' }}>
                          //       <ul
                          //         style={{
                          //           display: 'flex',
                          //           alignItems: 'center',
                          //         }}
                          //       >
                          //         <li
                          //           style={{
                          //             display: 'flex',
                          //             alignItems: 'center',
                          //             paddingRight: 40,
                          //           }}
                          //         >
                          //           <span
                          //             style={{
                          //               width: 5,
                          //               height: 36,
                          //               background: '#0F6CBD',
                          //               marginRight: 5,
                          //             }}
                          //           ></span>
                          //           <div>
                          //             <Text
                          //               size={12}
                          //               color={'#424242'}
                          //               style={{ lineHeight: 1.25 }}
                          //             >
                          //               매출
                          //             </Text>
                          //             <Text
                          //               size={16}
                          //               weight={600}
                          //               color={'#424242'}
                          //               style={{ lineHeight: 1.25 }}
                          //             >
                          //               0원
                          //             </Text>
                          //           </div>
                          //         </li>
                          //         <li
                          //           style={{
                          //             display: 'flex',
                          //             alignItems: 'center',
                          //           }}
                          //         >
                          //           <span
                          //             style={{
                          //               width: 5,
                          //               height: 36,
                          //               background: '#C50F1F',
                          //               marginRight: 5,
                          //             }}
                          //           ></span>
                          //           <div>
                          //             <Text
                          //               size={12}
                          //               color={'#424242'}
                          //               style={{ lineHeight: 1.25 }}
                          //             >
                          //               판매비율
                          //             </Text>
                          //             <Text
                          //               size={16}
                          //               weight={600}
                          //               color={'#424242'}
                          //               style={{ lineHeight: 1.25 }}
                          //             >
                          //               0%
                          //             </Text>
                          //           </div>
                          //         </li>
                          //       </ul>

                          //       {/* === NOTE: 매출데이터 === */}
                          //       {/*
                          //     매출데이터 컴포넌트 생성 후 쿼리API연동해서 매출 집계 필요
                          //     */}
                          //       <div ref={chartRef} style={{ marginTop: 20 }}>
                          //         <BarChart
                          //           width={chartWidth}
                          //           height={300}
                          //           data={
                          //             // salesStatistic
                          //             []
                          //           }
                          //         >
                          //           <XAxis
                          //             dataKey={'day'}
                          //             stroke="#686C73"
                          //             // tickFormatter={(d) => moment(d).format('MM-DD')}
                          //           />
                          //           <YAxis stroke="#686C73" />
                          //           <Tooltip />
                          //           <Bar
                          //             dataKey={'sales'}
                          //             fill={'var(--primary-color)'}
                          //           />
                          //         </BarChart>
                          //       </div>
                          //     </div>
                          //   ),
                          //   span: 4,
                          // },

                          {
                            key: `7`,
                            label: '등급혜택',
                            children: (
                              <Flex style={{ padding: '20px 0px' }} vertical>
                                {grades.map((_item) => {
                                  const gradeBenefit =
                                    selectedItem?.grade_benefit_info
                                      ? (selectedItem?.grade_benefit_info[
                                          _item.grade_id
                                        ] ?? GRADE_BENEFIT)
                                      : GRADE_BENEFIT;

                                  return (
                                    <Flex gap={4}>
                                      <Text weight={700}>
                                        {_item.grade_name}
                                        {' - '}
                                      </Text>
                                      <Flex gap={4}>
                                        <Text>
                                          할인: {gradeBenefit.discount_rate}
                                          {
                                            CONSTANTS.DISCOUNT_TYPE[
                                              gradeBenefit.discount_type
                                            ]
                                          }
                                        </Text>
                                        <Text>/</Text>
                                        <Text>
                                          적립: {gradeBenefit.reserve_rate}
                                          {
                                            CONSTANTS.DISCOUNT_TYPE[
                                              gradeBenefit.reserve_type
                                            ]
                                          }
                                        </Text>
                                      </Flex>
                                    </Flex>
                                  );
                                })}
                              </Flex>
                            ),
                            span: 4,
                          },
                        ]}
                      />
                    </Content>
                  </Col>
                </Row>
              </Content>
            </Col>
          </Row>
        </Content>
        {/* === 컨테이너: end === */}
      </Content>

      {/* 카테고리 추가 */}
      <ModalLayout
        type="modal"
        centered
        title={'카테고리 추가'}
        open={isOpened && modalType === 'category'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={500}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
            <Button
              type="primary"
              onClick={() =>
                onSubmit(
                  'category',
                  modalData?.category?.product_category_id
                    ? 'UPDATE'
                    : 'CREATE',
                )
              }
            >
              저장
            </Button>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={'30px 0px'}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                <div style={{ marginBottom: '20px' }}>
                  <Select
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="상위 카테고리 선택 (선택사항)"
                    value={modalData?.category?.parents_id}
                    onChange={(value) =>
                      onChange('parents_id', value, 'category')
                    }
                    options={[
                      { label: '상위 카테고리 없음', value: null },
                      ...(Array.isArray(data)
                        ? data
                            .filter(
                              (category) =>
                                !category.menus || category.menus.length === 0,
                            ) // 메뉴가 없는 카테고리만 필터링
                            .map((category) => ({
                              label: category.product_category_name,
                              value: category.product_category_id,
                            }))
                        : []), // data가 배열이 아닐 때 빈 배열로 처리
                    ]}
                  />
                </div>

                <div>
                  <Input
                    size="large"
                    count={{
                      show: true,
                      max: 20,
                    }}
                    placeholder="카테고리를 입력해주세요"
                    value={modalData?.category?.product_category_name}
                    onChange={(e) =>
                      onChange(
                        'product_category_name',
                        e.target.value,
                        'category',
                      )
                    }
                  />
                </div>
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>

      {/* 메뉴 추가/편집 */}
      <ModalLayout
        type="modal"
        centered
        title={'메뉴 추가'}
        open={isOpened && modalType === 'menu'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={'60%'}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
            <Button
              type="primary"
              onClick={() =>
                onSubmit('menu', modalData?.menu?.menu_id ? 'UPDATE' : 'CREATE')
              }
            >
              저장
            </Button>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={'30px 0px'}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                <Descriptions
                  items={[
                    {
                      key: 'menu_name',
                      label: '메뉴명',
                      children: (
                        <Input
                          size="large"
                          count={{
                            show: true,
                            max: 30,
                          }}
                          value={modalData?.menu?.menu_name}
                          placeholder="메뉴명을 입력해주세요"
                          onChange={(e) =>
                            onChange('menu_name', e.target.value, 'menu')
                          }
                        />
                      ),
                    },
                    {
                      key: 'price',
                      label: '단가',
                      children: (
                        <Input
                          size="large"
                          placeholder="금액을 입력해주세요"
                          value={modalData?.menu?.price}
                          onChange={(e) => {
                            const numericValue = parseInt(e.target.value, 10);
                            onChange(
                              'price',
                              isNaN(numericValue) ? 0 : numericValue,
                              'menu',
                            );
                          }}
                        />
                      ),
                    },
                    {
                      key: 'category',
                      label: '카테고리',
                      children: (
                        <div style={{ display: 'flex' }}>
                          <Select
                            size="large"
                            placeholder="카테고리를 선택해주세요"
                            value={modalData?.menu?.product_category_id}
                            onChange={(value) =>
                              onChange('product_category_id', value, 'menu')
                            }
                            options={data?.reduce((acc, category) => {
                              // subCategories가 있는 경우에는 그 하위 카테고리들을 보여준다
                              if (
                                category.subCategories &&
                                category.subCategories.length > 0
                              ) {
                                // 상위카테고리 > 하위카테고리 형식으로 subCategories를 추가
                                category.subCategories.forEach(
                                  (subCategory) => {
                                    const parentCategory =
                                      category.product_category_name;
                                    acc.push({
                                      label: `${parentCategory} > ${subCategory.product_category_name}`,
                                      value: subCategory.product_category_id,
                                    });
                                  },
                                );
                              } else {
                                // subCategories가 없는 상위 카테고리만 추가
                                acc.push({
                                  label: category.product_category_name,
                                  value: category.product_category_id,
                                });
                              }
                              return acc;
                            }, [])} // 빈 배열을 초기값으로 하여 각 카테고리를 축적
                          />
                        </div>
                      ),
                    },
                    {
                      key: 'type',
                      label: '메뉴 타입',
                      children: (
                        <Radio.Group
                          options={[
                            { label: '디저트', value: 'DESSERT' },
                            { label: 'MD', value: 'MD' },
                            { label: '일반', value: 'GENERAL' },
                            { label: '주류', value: 'ALC' },
                            { label: '기타', value: 'ETC' },
                          ]}
                          onChange={(e) =>
                            onChange('type', e.target.value, 'menu')
                          }
                          value={modalData?.menu?.type}
                          optionType="button"
                          buttonStyle="solid"
                        />
                      ),
                    },
                    {
                      key: 'is_show',
                      label: '노출 여부',
                      span: 2,
                      children: (
                        <Radio.Group
                          options={[
                            { label: '노출 안함', value: 'N' },
                            { label: '노출', value: 'Y' },
                          ]}
                          onChange={(e) =>
                            onChange('is_show', e.target.value, 'menu')
                          }
                          value={modalData?.menu?.is_show}
                          optionType="button"
                          buttonStyle="solid"
                        />
                      ),
                    },
                    {
                      key: 'sub_menu_name',
                      label: '서브메뉴명',
                      span: 2,
                      children: (
                        <Input
                          size="large"
                          value={modalData?.menu?.sub_menu_name}
                          placeholder="서브메뉴명을 입력해주세요"
                          onChange={(e) =>
                            onChange('sub_menu_name', e.target.value, 'menu')
                          }
                        />
                      ),
                    },
                    {
                      key: 'menu_content',
                      label: '설명',
                      span: 2,
                      children: (
                        <div style={{ padding: '20px 0px' }}>
                          <Input.TextArea
                            size="large"
                            placeholder="설명을 입력해주세요"
                            count={{
                              show: true,
                              max: 200,
                            }}
                            style={{ minHeight: 78 }}
                            value={modalData?.menu?.menu_content}
                            onChange={(e) =>
                              onChange('menu_content', e.target.value, 'menu')
                            }
                          />
                        </div>
                      ),
                    },
                    {
                      key: 'nutritional_information',
                      label: '영양 정보',
                      span: 2,
                      children: (
                        <div style={{ padding: '20px 0px' }}>
                          {(nutritionalInfo || []).map((info, index) => (
                            <div
                              key={`nutritional_info_${index}`}
                              style={{ marginBottom: 10 }}
                            >
                              <Input
                                placeholder="영양정보명"
                                value={info.nutritional_title}
                                onChange={(e) =>
                                  onNuritionalChange(
                                    'update',
                                    { nutritional_title: e.target.value },
                                    index,
                                  )
                                }
                                style={{ width: '30%', marginRight: '5px' }}
                              />
                              <Input
                                placeholder="양"
                                value={info.nutritional_amount}
                                onChange={(e) => {
                                  let value = e.target.value;

                                  // 숫자와 최대 소수점 1자리까지만 허용하는 정규식
                                  if (/^\d*\.?\d{0,1}$/.test(value)) {
                                    // 값이 비어있으면 0으로 설정
                                    value = value === '' ? '0' : value;
                                    onNuritionalChange(
                                      'update',
                                      { nutritional_amount: value },
                                      index,
                                    );
                                  }
                                }}
                                style={{ width: '30%', marginRight: '5px' }}
                              />
                              <Select
                                placeholder="단위"
                                value={info.nutritional_type}
                                onChange={(value) =>
                                  onNuritionalChange(
                                    'update',
                                    { nutritional_type: value },
                                    index,
                                  )
                                }
                                options={[
                                  { label: 'mg', value: 'mg' },
                                  { label: 'kcal', value: 'kcal' },
                                  { label: 'g', value: 'g' },
                                ]}
                                style={{ width: '30%' }}
                              />
                              <Button
                                type="danger"
                                style={{ marginLeft: '5px' }}
                                onClick={() =>
                                  onNuritionalChange('remove', {}, index)
                                }
                              >
                                X
                              </Button>
                            </div>
                          ))}

                          <Button
                            type="primary"
                            style={{ width: '100%' }}
                            onClick={() => onNuritionalChange('add')}
                          >
                            영양 정보 추가
                          </Button>
                        </div>
                      ),
                    },
                    {
                      key: 'allergen_ingredient',
                      label: '알레르기 유발 성분',
                      span: 2,
                      children: (
                        <Input
                          size="large"
                          placeholder="알레르기 유발 성분을 입력해주세요 (예: 땅콩/우유/난류)"
                          value={modalData?.menu?.allergen_ingredient}
                          onChange={(e) =>
                            onChange(
                              'allergen_ingredient',
                              e.target.value,
                              'menu',
                            )
                          }
                        />
                      ),
                    },
                    {
                      key: 'exchange_return_policy',
                      label: '교환/반품 안내',
                      span: 2,
                      children: (
                        <Input.TextArea
                          size="large"
                          placeholder="교환/반품 안내를 입력해주세요 (예: 해당 제품은 교환/환불이 불가합니다.)"
                          count={{
                            show: true,
                            max: 200,
                          }}
                          style={{ minHeight: 78 }}
                          value={modalData?.menu?.exchange_return_policy}
                          onChange={(e) =>
                            onChange(
                              'exchange_return_policy',
                              e.target.value,
                              'menu',
                            )
                          }
                        />
                      ),
                    },
                    {
                      key: 'is_present',
                      label: '선물 가능 여부',
                      children: (
                        <Radio.Group
                          options={[
                            { label: '가능', value: 'Y' },
                            { label: '불가능', value: 'N' },
                          ]}
                          onChange={(e) =>
                            onChange('is_present', e.target.value, 'menu')
                          }
                          value={modalData?.menu?.is_present}
                          optionType="button"
                          buttonStyle="solid"
                        />
                      ),
                      span: 2,
                    },
                    // [추가] 선물 관련 정보 (유효기간, 최대 연장 횟수)
                    {
                      key: 'present_information',
                      label: '선물 관련 정보',
                      children: (
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <Input
                            size="large"
                            placeholder="유효기간 (일)"
                            value={
                              modalData?.menu?.present_information
                                ?.present_expired_date ?? ''
                            }
                            onChange={(e) => {
                              const val = parseInt(e.target.value, 10);
                              // 기존 present_information 객체를 복사하여 present_expired_date 갱신
                              onChange(
                                'present_information',
                                {
                                  ...modalData?.menu?.present_information,
                                  present_expired_date: isNaN(val) ? '' : val,
                                },
                                'menu',
                              );
                            }}
                            disabled={modalData?.menu?.is_present === 'N'}
                          />
                          <Input
                            size="large"
                            placeholder="최대 연장 횟수"
                            value={
                              modalData?.menu?.present_information
                                ?.present_postponed_deadline ?? ''
                            }
                            onChange={(e) => {
                              const val = parseInt(e.target.value, 10);
                              onChange(
                                'present_information',
                                {
                                  ...modalData?.menu?.present_information,
                                  present_postponed_deadline: isNaN(val)
                                    ? ''
                                    : val,
                                },
                                'menu',
                              );
                            }}
                            disabled={modalData?.menu?.is_present === 'N'}
                          />
                        </div>
                      ),
                      span: 2,
                    },
                    {
                      key: 'thumbnail',
                      label: '메뉴 썸네일',
                      style: { padding: '10px 20px' },
                      children: (
                        <UploadFile
                          files={thumbnailFiles}
                          preview
                          multiple
                          max={1}
                          onChange={onThumbnailFileChange}
                        />
                      ),
                      span: 2,
                    },
                    {
                      key: 'menu_files',
                      label: '이미지',
                      span: 2,
                      children: (
                        <div style={{ padding: '20px 0px', display: 'flex' }}>
                          <UploadFile
                            files={files}
                            preview
                            multiple
                            max={5}
                            onChange={onFileChange}
                          />
                        </div>
                      ),
                    },
                    {
                      key: 'temperature_option',
                      label: '온도 옵션',
                      span: 2,
                      children: (
                        <Radio.Group
                          options={[
                            { label: 'HOT / ICE', value: 'ALL' },
                            { label: 'HOT ONLY', value: 'HOT' },
                            { label: 'ICE ONLY', value: 'ICE' },
                            { label: 'OTHER', value: 'OTHER' },
                          ]}
                          onChange={(e) =>
                            onChange(
                              'temperature_option',
                              e.target.value,
                              'menu',
                            )
                          }
                          value={modalData?.menu?.temperature_option}
                          optionType="button"
                          buttonStyle="solid"
                          disabled={
                            modalData?.menu?.type === 'MD' ||
                            modalData?.menu?.type === 'DESSERT' ||
                            modalData?.menu?.type === 'ALC' ||
                            modalData?.menu?.type === 'ETC'
                          }
                        />
                      ),
                    },
                    {
                      key: 'menu_option',
                      label: '옵션',
                      span: 2,
                      children: (
                        <div style={{ padding: '20px 0px' }}>
                          {options?.map((_item, _index) => (
                            <OptionForm
                              key={`option_form_${_index}`}
                              data={_item}
                              onChange={(d) => onOptionChange(d, _index)}
                              onRemove={() =>
                                onOptionList((prev) =>
                                  prev.filter((_, i) => _index !== i),
                                )
                              }
                            />
                          ))}
                          <div>
                            <Button
                              type="primary"
                              style={{ width: '100%' }}
                              onClick={() =>
                                // onOptionList((prev) => [...prev, optionTemp])
                                onOptionList((prevOptions) => [
                                  ...prevOptions,
                                  {
                                    ...optionTemp,
                                    option_id: prevOptions.length + 1, // 배열 길이에 기반하여 임시 option_id 생성
                                  },
                                ])
                              }
                            >
                              옵션 등록
                            </Button>
                          </div>
                        </div>
                      ),
                    },
                  ]}
                />
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </>
  );
};

export default MenuListPresenter;
